import { GetMatterTypes, GetMatterTypeColors } from '../actions/matters';

export default (store) => {
    store.dispatch(GetMatterTypes());
    store.dispatch(GetMatterTypeColors());
};
